/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Not_LinkedInputs */

const cs_enum_not_linked = /** @type {(inputs: Enum_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepropojeno`)
};

const en_enum_not_linked = /** @type {(inputs: Enum_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not linked`)
};

/**
* | output |
* | --- |
* | "Not linked" |
*
* @param {Enum_Not_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_not_linked = /** @type {((inputs?: Enum_Not_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Not_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_not_linked(inputs)
	return cs_enum_not_linked(inputs)
});